import extendService from './service.js';
import Service from '@/service/index.js';
export default {
  props: {
    extendDialogVisible: {
      type: Boolean,
      default: false
    },
    queryParams: {
      type: Object,
      default: {}
    }
  },
  data() {
    const validExtendReason = (rule, value, callback) => {
      if(Number(this.ruleForm.extendAnnouncementReason) === 2 &&
       !this.ruleForm.extendAnnouncementReasonStr) {
        callback(new Error('请输入其他原因'));
      } else {
        callback();
      }
    };
    return {
      approveStatusArr: [],
      extendReasonArr: [],
      ruleForm: {
        extendDays: '',
        remark: '',
        extendAnnouncementReason: '',
        extendAnnouncementReasonStr: ''
      },
      rules: {
        extendAnnouncementReason: [
          { required: true, message: '请选择延长原因', trigger: 'change' },
          { required: true, validator: validExtendReason, trigger: 'blur' }
        ],
        extendDays: [
          { required: true, message: '请选择延长天数', trigger: 'change' }
        ]
      },
      tableList: []
    };
  },
  watch: {
    extendDialogVisible (flag) {
      if (flag) {
        this.ruleForm = {
          extendDays: '',
          remark: '',
          extendAnnouncementReason: '',
          extendAnnouncementReasonStr: ''
        };
        this.$refs['ruleForm']?.resetFields();

        this.getSelectList('EXTEND_APPROVE_STATUS');
        this.getSelectList('EXTEND_ANNOUNCEMENT_REASON');
        this.getExtendHistory();
      }
    }
  },
  methods: {
    getSelectList (key) {
      Service.getSelectList(key).then(({code, data}) => {
        if (code === '0') {
          if (key === 'EXTEND_APPROVE_STATUS') {
            this.approveStatusArr = data;
          } else {
            this.extendReasonArr = data;
          }
        }
      });
    },
    cancelExtend () {
      this.$emit('update:extendDialogVisible', false);
    },
    // 确认选择
    confirmExtend () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$emit('update:extendDialogVisible', false);
          let params = {
            ...this.queryParams,
            ...this.ruleForm
          };
          extendService.extendAnnouncement(params).then(res => {
            if (res && res.code === '0') {
              this.$successMessage('延长公告信息成功');
              this.$emit('getResultList');
            }
          }, (error) => {
            if (error && error.data && error.data.reason) {
              this.$errorMessage(error.data.reason);
            } else {
              this.$errorMessage('延长公告信息失败');
            }
          });
        }
      });
    },
    // 延长记录列表
    getExtendHistory () {
      extendService.getExtendHistory(this.queryParams).then(({code, data}) => {
        if (code === '0') {
          this.tableList = data;
        }
      });
    },
    // 跳转到延长公告详情
    toExtendDetail (newsId) {
      this.$router.push('/notice-modular/trading-rules-detail?id=' + newsId);
    }
  }
};
